module.exports = __webpack_public_path__ + "static/media/supplyManagementWhite.c978d9f4.svg";